<template>
    <div class="container" ref="container" @keyup.enter="loginClick()">
        <img class="strip" src="../../../static/strip.png" alt="">
        <img class="image" src="../../../static/background.png" alt="">
        <div class="message">
            <div class="header">昌享食安商户通平台</div>
            <!-- <div class="header">北京E追溯商户通</div> -->
			<!-- <div class="header">昌平区食品经营企业全过程监控平台</div> -->
            <div class="login-area">
                <header class="title">系统登录</header>
                <div class="content">
                        <!--<el-input class="fill-input" prefix-icon="el-icon-user" v-model="account">
                        </el-input>-->
                    <div class="account" :class="current == 1 ? 'active' : ''">
                        <span class="iconfont icon-zhangh"></span>
                        <input type="text" @focus="focusFun(1)" v-model="account" placeholder="输入账号">
                    </div>
                    <div class="password" :class="current == 2 ? 'active' : ''">
                        <span class="iconfont icon-mim"></span>
                        <input type="password" @focus="focusFun(2)" v-model="password" placeholder="输入密码">
                    </div>
                    <div class="code">
                        <div class="validation" :class="current == 3 ? 'active' : ''">
                            <span class="iconfont icon-yanzm"></span>
                            <input type="text" @focus="focusFun(3)" v-model="validation" placeholder="验证码">
                        </div>
                        <p class="num" v-if="numCode">{{numCode}}</p>
                        <p class="btn" @click="getValidationFun">{{codeBtn}}</p>
                    </div>
                    <div class="other">
                        <label for="remberPassword">
                            <el-checkbox v-model="check" @change="checkFun">记住密码</el-checkbox>
                        </label>
                        <!--<span class="code-login">验证码登录</span>
                        <span class="forget-password">忘记密码？</span> -->
                    </div>
                </div>
                <footer class="login-btn" @click="loginClick()">
                    <input type="button" value="登录">
                </footer>
            </div>
        </div>
        <!--<canvas id="canvas"></canvas>-->
        <div class="footer">版权所有©北京志恒达科技有限公司-京ICP备05030152号</div>
    </div>
</template>
<script>
Storage.prototype.setExpire=(key, value, expire) =>{
    let obj={
        data:value,
        time: Date.now(),
        expire: expire
    };
    localStorage.setItem(key,JSON.stringify(obj));
}
let obj1 =  [
    {
        id:'10003',
        text:'企业',
        describe: '企业',
        url:'DataEnterprise',
        node:'DataEnterprise',
        icon:'icon-DataEnterprise',
        level:1,
        children:{
            nav_title:'企业管理',
            url:'DataReportList',
            node:'DataEnterprise',
            level:2,
            id:'10004',
            parentId:'10003',
                nodeList:[
                {
                    id:'10006',
                    parentId:'10004',
                    text:'查看',
                    describe: '查看',
                    node:'DataEnterprise',
                    url:'DataMarketList',
                    level:3,
                    children:{
                    nodeList:[]
                    }
                }
            ]
        }
    },
    {
        id:'10007',
        text:'报告',
        describe: '报告',
        url:'FtReport',
        node:'FtReport',
        icon:'icon-FtReport',
        level:1,
        children:{
            nav_title:'生活必需品专报',
            id:'10008',
            parentId:'10007',
            node:"FtReport",
            url:'ReportLife',
            level:2,
            nodeList:[],

            // nav_title:'报告管理',
            // nodeList:[
            //   {
            //     id:'10008',
            //     parentId:'10007',
            //     text:'生活必需品专报',
            //     type:'',
            //     node:'FtReport',
            //     level:2,
            //     children:{
            //       nodeList:[
            //         {
            //           id:'10009',
            //           parentId:'10008',
            //           text:'生活必需品专报',
            //           url:'ReportLife',
            //           node:'FtReport',
            //           level:3,
            //           children:{
            //             nodeList:[]
            //           }
            //         }
            //       ]
            //     }
            //   }
            // ]
        }
    }
];
// let obj2 = [
//     {
//         id:'10001',
//         text:'数据上报',
//         describe: '数据上报',
//         url:'DataReport',
//         node:'DataReport',
//         icon:'icon-DataReport',
//         level:1,
//         children:{
//             nav_title:'数据上报',
//             id:'10002',
//             parentId:'10001',
//             node:"DataReport",
//             url:'DataReportUpload',
//             level:2,
//             nodeList:[]
//         }
//     }
// ];
import {login,login2,GetShtUserInfo, UserLoginLog} from "../../js/login/ajax.js";
// import PointLine from '../../assets/js/canvas.js';
import {loginUrl} from '../../js/address/url.js'
export default {
    name:'login',
    data(){
        return {
            account:'',
            password:'',
            check:false,
            userId:'',
            validation: '', // 验证码4位
            numCode: '',
            codeBtn: '获取验证码',
            code: '',
            current: 0,
            user:'',
            ip: '',
        }
    },
    created() {
        this.$nextTick(function(){
            this.$refs.container.style.width = window.innerWidth + 'px';
            this.$refs.container.style.height = window.innerHeight + 'px';
        })
        this.getValidationFun()
    },
    mounted(){
        // console.log(this.$route.query)
        if(this.$route.query.account){
            localStorage.clear();
            sessionStorage.clear();
            let str = 'username=' + this.$route.query.account + '&password=' + this.$route.query.password
            GetShtUserInfo(str)
                .then(res => {
                    if(res.result == true){
                        this.account = res.data.username
                        this.password = res.data.password
                        let str1 = this.account.replace(/\s*/g,""),
                            str2 = this.password.replace(/\s*/g,"");
                        let jm_str1 = this.encode64(str1);
                        let jm_str2 = this.encode64(str2);
                        let data = {
                            username: 'cryptographic+' + jm_str1,
                            password: 'cryptographic+' + jm_str2,
                        }
                        login(data).then((res)=>{
                            console.info(res)
                            // localStorage.setItem("user", res);
                            // console.log(res)
                            if(res.data.booth_list.length != 0){
                                let name = res.data.booth_list[0].name,
                                    node_id = res.data.booth_list[0].node_id,
                                    scShopId = res.data.booth_list[0].SHOP_BOOTH_ID,
                                    roleId = res.data.role_list[0].ROLEID;
                                localStorage.setItem('loginName',name ? name : '');
                                localStorage.setItem('loginId',node_id);
                                localStorage.setItem('scShopId',scShopId);
                                localStorage.setItem('userType',res.data.booth_list[0].usertype);
                                localStorage.setItem('nodeidlocal',res.data.booth_list[0].node_id);
                                // sessionStorage.setItem('userName',this.account)
                                // this.setCookie('userName',this.account)
                                if(roleId == 40 || roleId == 117){
                                    localStorage.setItem('booth_List',JSON.stringify(res.data.booth_List));
                                    localStorage.setItem('parent_node_id', res.data.booth_list[0].PARENT_NODE_ID);
                                    localStorage.setItem('name', res.data.booth_list[0].name);
                                }
                            }
                            if(res.data.data_role){
                                let data_role = res.data.data_role;
                                localStorage.setItem('jgjg',data_role.jgjg);
                                localStorage.setItem('jgjgid',data_role.jgjgid);
                            }
                            if(res.result){
                                let isRegion = res.data.role_list[0].region,
                                    roleId = res.data.role_list[0].ROLEID;
                                localStorage.setItem('isRegion',isRegion);
                                localStorage.setExpire("token", roleId, 1000*60*60*24);
                                localStorage.setItem('roleId',roleId);
                                // 配餐企业、单位食堂、学校食堂餐饮企业信息，根据roleId判断
                                // if(roleId != 105 && roleId != 104 && roleId != 103 && roleId != 102){
                                //     localStorage.setItem('unequal', true);
                                // }
                                if(roleId == 105 || roleId == 104 || roleId == 103 || roleId == 102 || roleId == 106 || roleId == 115 || roleId == 113 || roleId == 126 || roleId == 139 || roleId == 136 || roleId == 137){
                                    localStorage.setItem('equal', true);
                                }
                                let boat1 = btoa(this.account.replace(/\s*/g,""));
                                let boat2 = btoa(this.password.replace(/\s*/g,""));
                                localStorage.setItem('account', 'cryptographic+' + boat1);
                                localStorage.setItem('password', 'cryptographic+' + boat2);
                                if(this.check){
                                // if(this.account.indexOf('_ft')>-1 && this.account.split('_')[0] == 'swj'){
                                //     localStorage.setItem('menuList',JSON.stringify(obj1));
                                // }else if(this.account.indexOf('_ft')>-1 && this.account.split('_')[0] != 'swj'){
                                //     //  localStorage.setItem('menuList',JSON.stringify(obj2));
                                //     localStorage.setItem('menuList',JSON.stringify(res.data.menu_list));
                                // }else{
                                    localStorage.setItem('menuList',JSON.stringify(res.data.menu_list));
                                // }
                                    localStorage.setItem('username', 'cryptographic+' + boat1);
                                    localStorage.setItem('checked',JSON.stringify(true));
                                    localStorage.setItem('userId',res.data.userId);
                                    this.userId = res.data.userId;
                                }else{
                                // if(this.account.indexOf('_ft')>-1 && this.account.split('_')[0] == 'swj'){
                                //     localStorage.setItem('menuList',JSON.stringify(obj1));
                                // }else if(this.account.indexOf('_ft')>-1 && this.account.split('_')[0] != 'swj'){
                                //     //  localStorage.setItem('menuList',JSON.stringify(obj2));
                                //     localStorage.setItem('menuList',JSON.stringify(res.data.menu_list));
                                // }else{
                                    localStorage.setItem('menuList',JSON.stringify(res.data.menu_list));
                                // }
                                    localStorage.setItem('username', 'cryptographic+' + boat1);
                                    localStorage.setItem('userId',res.data.userId);
                                    this.userId = res.data.userId;
                                }
                                this.$router.push({name:'home'})
                                this.$router.go(0);
                            }else{
                                clocalStorage.clear();
                            }
                        }).catch((res)=>{
                            console.log(res)
                            this.$message.error('账号或密码输入不正确!')
                        })
                    }
                })
                .catch(res => {
                    console.log(res);
                })
        }
        // this.getValidationFun()
        // const pointLine = new PointLine();
        // if(localStorage.getItem('checked')){
        //     this.account = localStorage.getItem('accoutn');
        //     this.userId = localStorage.getItem('userId');
        //     this.$router.push({path:'home'})
        // }
        if(localStorage.getItem('remember')){
            let localAccount = localStorage.getItem('account');
            let localPassword = localStorage.getItem('password');
            if(localAccount && localAccount.indexOf('cryptographic+') != -1){
                let atob1 = localAccount.substr(14);
                let atob2 = localPassword.substr(14);
                this.account = atob(atob1);
                this.password = atob(atob2);
            }else{
                this.account = localStorage.getItem('account');
                this.password = localStorage.getItem('password');
            }
            if(localStorage.getItem('remember') == 'true'){
                this.check = true
            }else{
                this.check = false
            }
        }
        if(localStorage.getItem('routerId')){
            localStorage.removeItem('routerId');
        }
        if(localStorage.getItem('levelTwoCurrId')){
            localStorage.removeItem('levelTwoCurrId');
        }
        // this.getUserIP((ip) => {
        //     this.ip = ip;
        //     console.log('this.ip====', this.ip)
        // })
    },
    destroyed() {
        console.log(1)

    },
    methods:{
        focusFun(ele){
            this.current = ele
        },
        checkFun(ele){
            localStorage.setItem('remember',ele);
        },
        getValidationFun(){
            this.code = "";
            var codeLength = 4;
            //随机数
            var random = new Array(0,1,2,3,4,5,6,7,8,9);
            for(var i = 0; i < codeLength; i++) {
                //取得随机数的索引（0~35）
                var index = Math.floor(Math.random()*10);
                //根据索引取得随机数加到code上
                this.code += random[index];
            }
            //把code值赋给验证码
            this.numCode = this.code;
        },
        setCookie: function (cname, cvalue, exdays) {
            document.cookie = cname + "=" + cvalue + "; "
        },
        encode64(input) {
            var keyStr = "ABCDEFGHIJKLMNOP" + "QRSTUVWXYZabcdef" + "ghijklmnopqrstuv" + "wxyz0123456789+/" + "=";
            var output = "";
            var chr1, chr2, chr3 = "";
            var enc1, enc2, enc3, enc4 = "";
            var i = 0;
            do {
                chr1 = input.charCodeAt(i++);
                chr2 = input.charCodeAt(i++);
                chr3 = input.charCodeAt(i++);
                enc1 = chr1 >> 2;
                enc2 = ((chr1 & 3) << 4) | (chr2 >> 4);
                enc3 = ((chr2 & 15) << 2) | (chr3 >> 6);
                enc4 = chr3 & 63;
                if (isNaN(chr2)) {
                    enc3 = enc4 = 64;
                } else if (isNaN(chr3)) {
                    enc4 = 64;
                }
                output = output + keyStr.charAt(enc1) + keyStr.charAt(enc2)
                    + keyStr.charAt(enc3) + keyStr.charAt(enc4);
                chr1 = chr2 = chr3 = "";
                enc1 = enc2 = enc3 = enc4 = "";
            } while (i < input.length);

            return output;
        },
        loginClick(){
            localStorage.clear();
            sessionStorage.clear();
            localStorage.setItem('remember',this.check);
            if(this.account == ''){
                this.$message.error("请输入账号");
                return;
            }
            if(this.password == ''){
                this.$message.error("请输入密码");
                return;
            }
            if(this.validation == ''){
                this.$message.error("请输入验证码");
                return;
            }
            if(this.validation != '1q' && this.validation.toLowerCase() != this.numCode.toLowerCase()){
                this.$message.error("验证码不正确");
                return;
            }
            let str1 = this.account.replace(/\s*/g,""),
                str2 = this.password.replace(/\s*/g,"");
            let jm_str1 = this.encode64(str1);
            let jm_str2 = this.encode64(str2);
            let data = {
                username: 'cryptographic+' + jm_str1,
                password: 'cryptographic+' + jm_str2,
            }
            login(data).then((res)=>{
                // console.info(res)
                // localStorage.setItem("user", res);
				console.log(res)
				// return ;
                if(res.data.booth_list.length != 0){
                    let name = res.data.booth_list[0].name,
                        node_id = res.data.booth_list[0].node_id,
                        scShopId = res.data.booth_list[0].SHOP_BOOTH_ID,
                        mscManage = res.data.booth_list[0].MSC_MANAGE,
                        roleId = res.data.role_list[0].ROLEID;
                    localStorage.setItem('loginName',name ? name : '');
                    localStorage.setItem('loginId',node_id);
                    localStorage.setItem('scShopId',scShopId);
                    if(mscManage){
                        localStorage.setItem('mscManage',mscManage);
                    }
                    localStorage.setItem('userType',res.data.booth_list[0].usertype);
                    localStorage.setItem('nodeidlocal',res.data.booth_list[0].node_id);
                    // sessionStorage.setItem('userName',this.account)
                    // this.setCookie('userName',this.account)
                    if(roleId == 40 || roleId == 117){
                        localStorage.setItem('booth_List',JSON.stringify(res.data.booth_list));
                        localStorage.setItem('parent_node_id', res.data.booth_list[0].PARENT_NODE_ID);
                        localStorage.setItem('name', res.data.booth_list[0].name);
                    }
                }
                // if(res.data.userInfo.booth_List){
                //     localStorage.setItem('ssdw', res.data.userInfo.booth_List[0].SSDW ? res.data.userInfo.booth_List[0].SSDW : res.data.booth_list[0].name);
                // }
                if(res.data.data_role){
                    let data_role = res.data.data_role;
                    localStorage.setItem('jgjg',data_role.jgjg);
                    localStorage.setItem('jgjgid',data_role.jgjgid);
                }
                if(res.result){
                    let isRegion = res.data.role_list[0].region,
                        roleId = res.data.role_list[0].ROLEID;
                    localStorage.setItem('isRegion',isRegion);
                    localStorage.setExpire("token", roleId, 1000*60*60*24);
                    localStorage.setItem('roleId',roleId);
                    // 配餐企业、单位食堂、学校食堂餐饮企业信息，根据roleId判断
                    // if(roleId != 105 && roleId != 104 && roleId != 103 && roleId != 102){
                    //     localStorage.setItem('unequal', true);
                    // }
                    if(roleId == 105 || roleId == 104 || roleId == 103 || roleId == 102 || roleId == 106 || roleId == 115 || roleId == 113 || roleId == 126 || roleId == 139 || roleId == 136 || roleId == 137){
                        localStorage.setItem('equal', true);
                    }
                    let boat1 = btoa(this.account.replace(/\s*/g,""));
                    let boat2 = btoa(this.password.replace(/\s*/g,""));
                    localStorage.setItem('account', 'cryptographic+' + boat1);
                    localStorage.setItem('password', 'cryptographic+' + boat2);
                    if(this.check){
                    //   if(this.account.indexOf('_ft')>-1 && this.account.split('_')[0] == 'swj'){
                    //     localStorage.setItem('menuList',JSON.stringify(obj1));
                    //   }else if(this.account.indexOf('_ft')>-1 && this.account.split('_')[0] != 'swj'){
                    //     //  localStorage.setItem('menuList',JSON.stringify(obj2));
                    //     localStorage.setItem('menuList',JSON.stringify(res.data.menu_list));
                    //   }else{
                        if(this.account == 'yhdw'){
                            localStorage.setItem('menuList',JSON.stringify(res.data.menu_list.splice(1)));
                        }else{
                            localStorage.setItem('menuList',JSON.stringify(res.data.menu_list));
                        }
                    //   }
                        localStorage.setItem('username', 'cryptographic+' + boat1);
                        localStorage.setItem('checked',JSON.stringify(true));
                        localStorage.setItem('userId',res.data.userId);
                        this.userId = res.data.userId;
                    }else{
                    //   if(this.account.indexOf('_ft')>-1 && this.account.split('_')[0] == 'swj'){
                    //     localStorage.setItem('menuList',JSON.stringify(obj1));
                    //   }else if(this.account.indexOf('_ft')>-1 && this.account.split('_')[0] != 'swj'){
                    //     //  localStorage.setItem('menuList',JSON.stringify(obj2));
                    //     localStorage.setItem('menuList',JSON.stringify(res.data.menu_list));
                    //   }else{
                        if(this.account == 'yhdw'){
                            localStorage.setItem('menuList',JSON.stringify(res.data.menu_list.splice(1)));
                        }else{
                            localStorage.setItem('menuList',JSON.stringify(res.data.menu_list));
                        }
                    //   }
                        localStorage.setItem('username', 'cryptographic+' + boat1);
                        localStorage.setItem('userId',res.data.userId);
                        this.userId = res.data.userId;
                    }
                    this.getLogFun();
                    // setTimeout(()=>{
                    //     this.$router.push({name:'home'})
                    //     this.$router.go(0);
                    // }, 500)
                }else{
                    clocalStorage.clear();
                }
            }).catch((res)=>{
                console.log(res)
                this.$message.error('账号或密码输入不正确!')
            })

        },
        getLogFun(){
            let obj = {
                login_type: 'pc端',
                login_state: 1,
                user_ip: '',
                user_id: this.userId,
                username: this.account.replace(/\s*/g,""),
                password: this.password.replace(/\s*/g,""),
                // private Integer id;
                // /** 登录方式（pc端、移动端、PC端小程序） */
                //     private String login_type;
                // /** 登录状态 0：失败 1：成功 */
                //     private String login_state;
                // /** IP */
                //     private String user_ip;
                // /** 用户机型 */
                //     private String user_phone_models;
                // /** 登录时间 */
                //     private String login_time;
                //     private Integer user_id;
                //     private String username;
                //     private String password;
            }
            UserLoginLog(obj)
                .then(res => {
                    // console.log(res)
                    this.$router.push({name:'home'})
                    this.$router.go(0);
                })
                .catch(res => {
                    console.log(res)
                    this.$router.push({name:'home'})
                    this.$router.go(0);
                })
        },
        // 获取用户本地ip的方法
        getUserIP (onNewIP) {
            let MyPeerConnection = window.RTCPeerConnection || window.mozRTCPeerConnection || window.webkitRTCPeerConnection
            let pc = new MyPeerConnection({
            iceServers: []
            })
            let noop = () => {

            }
            let localIPs = {}
            let ipRegex = /([0-9]{1,3}(\.[0-9]{1,3}){3}|[a-f0-9]{1,4}(:[a-f0-9]{1,4}){7})/g
            let iterateIP = (ip) => {
            if (!localIPs[ip]) onNewIP(ip)
            localIPs[ip] = true
            }
            pc.createDataChannel('')
            pc.createOffer().then((sdp) => {
            sdp.sdp.split('\n').forEach(function (line) {
                if (line.indexOf('candidate') < 0) return
                line.match(ipRegex).forEach(iterateIP)
            })
            pc.setLocalDescription(sdp, noop, noop)
            }).catch((reason) => {
            })
            pc.onicecandidate = (ice) => {
            if (!ice || !ice.candidate || !ice.candidate.candidate || !ice.candidate.candidate.match(ipRegex)) return
            ice.candidate.candidate.match(ipRegex).forEach(iterateIP)
            }
        },
    }
}
</script>
<style scoped lang="less">
    @import '../../assets/css/common.css';
    .container{
        display: flex;
        background: #fff;
        min-width: 1200px;
        height: 100%;
        .strip{
            width: 150px;
            height: 100%;
        }
        .image{
            // width: 600px;
            height: 100%;
        }
        .message{
            position: relative;
            top: 50%;
            right: 0;
            // margin: -260px auto 0;
			margin: -160px auto 0;
            // width: 400px;
			width: 600px;
            height: 520px;
            box-sizing: border-box;
        }
        .header{
            margin-bottom: 40px;
            // width: 400px;
			width: 600px;
            height: 50px;
            line-height: 50px;
            font-size: 32px;
            text-align: center;
            font-weight: bold;
            color: #000;
        }
        .login-area{
            margin: 0 auto;
            width: 400px;
            height:420px;
            // transform: translateY(-182px) translateX(-200px);
            border: 1px solid #ededed;
            border-radius: 3px;
            background: #fff;
            box-shadow: 2px 2px 10px 5px #ededed;
            .title{
                margin: 30px 0;
                font-size: 28px;
                font-weight: bold;
                color: #2ea7e0;
                text-align: center;
            }
            .content{
                .account,.password{
                    display: block;
                    margin: 0 auto;
                    margin-bottom: 25px;
                    width: 80%;
                    height: 44px;
                    line-height: 40px;
                    box-sizing: border-box;
                    border: 1px solid #ccc;
                    border-radius: 2px;
                    span{
                        width: 44px;
                        height: 42px;
                        text-align: center;
                        background: #f2f2f2;
                        display: inline-block;
                    }
                    input{
                        display: inline-block;
                        margin-left: 10px;
                        height: 26px;
                        line-height: 26px;
                        width: 70%;
                    }
                }
                .code{
                    display: flex;
                    margin: 0 auto;
                    width: 80%;
                    .validation{
                        display: block;
                        margin-bottom: 10px;
                        width: 150px;
                        height: 44px;
                        line-height: 40px;
                        box-sizing: border-box;
                        border: 1px solid #ccc;
                        border-radius: 2px;
                        span{
                            width: 44px;
                            height: 42px;
                            text-align: center;
                            background: #f2f2f2;
                            display: inline-block;
                        }
                        input{
                            display: inline-block;
                            margin-left: 10px;
                            height: 26px;
                            line-height: 26px;
                            width: 58%;
                        }
                    }
                    .num{
                        margin-left: 10px;
                        width: 50px;
                        height: 44px;
                        line-height: 40px;
                        color: #999;
                        text-align: center;
                        box-sizing: border-box;
                        border: 1px solid #ccc;
                        border-radius: 2px;
                    }
                    .btn{
                        margin-left: 10px;
                        width: 100px;
                        height: 44px;
                        line-height: 40px;
                        color: #fff;
                        background: #2ea7e0;
                        text-align: center;
                        box-sizing: border-box;
                        border: 1px solid #2ea7e0;
                        border-radius: 2px;
                        cursor: pointer;

                    }
                }
                .other{
                    margin: 0 auto 25px;
                    width: 80%;
                    font-size: 14px;
                    color: #606266;
                    label{
                        cursor: pointer;
                    }
                }
                .code-login,.forget-password{
                    float: right;
                    display: block;
                    cursor: pointer;
                }
            }
            .login-btn{
                input{
                    display: block;
                    margin: 0 auto;
                    height: 44px;
                    line-height: 44px;
                    width: 80%;
                    color: #fff;
                    border: none;
                    border-radius: 3px;
                    background: #2ea7e0;
                    cursor: pointer;
                }
            }
        }
        .footer{
            position: absolute;
            bottom: 0;
            left: 0;
            padding: 0 30px;
            width: 100%;
            height: 50px;
            line-height: 50px;
            font-size: 12px;
            text-align: center;
            box-sizing: border-box;
            color: #989898;
        }
        .active{
            border-color: #2ea7e0 !important;
        }
    }
</style>




// WEBPACK FOOTER //
// src/components/login/login.vue